import { useSnackbar } from 'notistack';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  addLegInShipment,
  makeShipment,
  manualShipment,
} from '../../../api/shipmentForms';
import { useShipForm } from '../../../context/shipForms';
import { BCShippingFields } from '../../../initial-values';
import { BCFieldsDto, ContactDto, ReferenceRouteFormDto } from '../../../types';
import {
  mapShipPayloadData,
  removeNullProperties,
} from '../../../utils/helper';
import AlertModal from '../../global-components/alertModal';
import ShippingPaymentLoading from '../payment/shippingPaymentLoading';
import BusinessCentralMainForm from './businessCentralForm';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import stairs_placeholder from '../../../assets/icons/new_icon/stairs1.png';
import { AbilityContext } from '../../../context/AbilityContext';
interface Props {
  setShowSummary?: any;
  setShowPayment?: any;
  setCurrentShipmentStatus?: any;
  isManualLegs?: boolean;
  setShowLegsForm?: any;
  setShowBCScreen?: any;
}
function MainBusinessPaymentPage({
  setShowSummary,
  setCurrentShipmentStatus,
  setShowPayment,
  isManualLegs,
  setShowLegsForm,
  setShowBCScreen,
}: Props) {
  const {
    getSelectedPlanningLaneContext,
    getRatesApiPayloadContext,
    getRatesApiDataContext,
    getReferenceFormDataContext,
    getShipperFormData,
    getConsigneeFormData,
    getSpecialInstructionContext,
    getPickupPayloadContext,
    getSelectedRateContext,
    getShippingDocsContext,
    getSelectedServiceContext,
    getSelectedAccountContext,
    getSelectedManualLegsContext,
    getBrokerFormDataContext,
    getSelectedJobContext,
    getAddLegShipmentDataContext,
    getAllCommoditiesContext,
    getFinalRateContext,
  } = useShipForm();
  const navigate = useNavigate();
  const location = useLocation();
  const isAddLegs = location?.pathname === '/app/add-leg';
  const ability = useContext(AbilityContext);
  const isAdmin = ability.can('read', 'Admin Shipments');
  const quote_id = new URLSearchParams(location.search).get('quote_id');
  const userData = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const ratesApiPayloadContext: any = getRatesApiPayloadContext();
  const ratesApiDataContext: any = getRatesApiDataContext();
  const referenceFormDataContext: ReferenceRouteFormDto =
    getReferenceFormDataContext();
  const shipperFormData: ContactDto = getShipperFormData();
  const consigneeFormData: ContactDto = getConsigneeFormData();
  const specialInstructionContext: string = getSpecialInstructionContext();
  const pickupPayloadContext: any = getPickupPayloadContext();
  const selectedRateContext: any = getSelectedRateContext();
  const shippingDocsContext: any = getShippingDocsContext();
  const servicesDataContext: any = getSelectedServiceContext();
  const selectedAccountContext: any = getSelectedAccountContext();
  const selectedJobContext: any = getSelectedJobContext();
  const planningLinesContext = getSelectedPlanningLaneContext();
  const selectedManualLegsContext = getSelectedManualLegsContext();
  const brokerFormDataContext = getBrokerFormDataContext();
  const addLegShipmentDataContext = getAddLegShipmentDataContext();
  const allCommoditiesContext = getAllCommoditiesContext();
  const finalCostContext = getFinalRateContext();
  const { enqueueSnackbar } = useSnackbar();
  const [section, setSection] = useState('NF');
  const [bcTypeForm, setBCTypeForm] = useState<BCFieldsDto>(BCShippingFields);
  const [bcCustomerCode, setBcCustomerCode] = useState<any>('');
  const [bcCustomerName, setBcCustomerName] = useState<any>('');
  const [isAllIn, setIsAllIn] = useState(false);
  const [isHandling, setIsHandling] = useState(true);
  const [description, setDescription] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shippingError, setShippingError] = useState('');
  useEffect(() => {
    setBCTypeForm({
      ...bcTypeForm,
      bc_type: section,
      bc_planning_lines: planningLinesContext,
      bc_username: userData?.bc_username,
      bc_location: userData?.bc_location_code,
      bc_customer_reference_one: referenceFormDataContext?.reference_1,
      bc_customer_reference_two: referenceFormDataContext?.reference_2,
    });
  }, []);

  function handleBack() {
    setShowPayment(false);
    setShowSummary(true);
    setCurrentShipmentStatus('summary');
  }
  function handleSection(type: string) {
    setSection(type);
    setBCTypeForm({
      ...bcTypeForm,
      bc_type: type,
    });
  }

  function handleSkipPayment(type: string) {
    // setSection(type);
    setBCTypeForm({
      ...bcTypeForm,
      bc_type: type,
    });
    setTimeout(() => {
      handleShip(true);
    }, 300);
  }

  function handleShip(isSkip?: boolean) {
    let isValid = true;
    if (isAllIn) {
      const areAllValuesOne = bcTypeForm.bc_planning_lines
        .filter((item) => ['P', 'A1', 'T', 'A2', 'D'].includes(item.leg))
        .every((item) => item.line_type === '1');
      isValid = areAllValuesOne;
      if (!areAllValuesOne) {
        enqueueSnackbar(
          'All shipment legs must be budget if All In is selected.',
          {
            variant: 'error',
          }
        );
      }
    } else {
      bcTypeForm.bc_planning_lines = bcTypeForm.bc_planning_lines.filter(
        (item) => item.leg !== 'Allin'
      );
    }
    if (!isHandling) {
      bcTypeForm.bc_planning_lines = bcTypeForm.bc_planning_lines.filter(
        (item) => item.leg !== 'Handling'
      );
    }
    if (isSkip || bcTypeForm.bc_type === 'SK') {
      setDescription(
        'Are you sure you want to skip Job File Creation or update.'
      );
      setShowAlert(true);
      return;
    }

    if (
      bcTypeForm.bc_type === 'NF' &&
      bcTypeForm.bc_customer === '' &&
      isValid
    ) {
      enqueueSnackbar('Please select a customer.', {
        variant: 'error',
      });
      isValid = false;
      return;
    }
    if (
      bcTypeForm.bc_job_number === '-1' &&
      bcTypeForm.bc_type === 'UF' &&
      isValid
    ) {
      enqueueSnackbar('Please select a job file.', {
        variant: 'error',
      });
      isValid = false;
      return;
    }
    if (bcTypeForm.bc_type === 'UF' && isValid) {
      setDescription('Are you sure you want to add to a existing Job File?');
      setShowAlert(true);
      return;
    }
    if (bcTypeForm.bc_type === 'NF' && isValid) {
      setDescription('Are you sure you want to create a new Job File?');
      setShowAlert(true);
      return;
    }
  }

  function makeShipmentHandle() {
    setShowAlert(false);
    setLoading(true);
    setCurrentShipmentStatus('Loading');
    let payload = mapShipPayloadData(
      ratesApiPayloadContext,
      ratesApiDataContext,
      referenceFormDataContext,
      shipperFormData,
      consigneeFormData,
      specialInstructionContext,
      undefined,
      pickupPayloadContext,
      selectedRateContext,
      true,
      undefined,
      shippingDocsContext,
      servicesDataContext,
      bcTypeForm,
      selectedAccountContext,
      selectedManualLegsContext,
      brokerFormDataContext,
      quote_id,
      selectedJobContext,
      addLegShipmentDataContext?.shipment_id,
      allCommoditiesContext,
      finalCostContext
    );

    if (userData?.is_bbe === true) {
      payload = {
        ...payload,
        bc_customer_code: bcCustomerCode,
        bc_customer_name: bcCustomerName,
      };
    }

    payload = removeNullProperties(payload);
    if (isManualLegs) {
      makeManualShipment(payload);
      return;
    }
    if (isAddLegs) {
      makeAddLeg(payload);
      return;
    }

    let shipPayload: any = payload;
    shipPayload.shipment = payload?.service;
    delete shipPayload.service;
    if (!shipPayload?.moneris_token) {
      delete shipPayload?.billing;
    }
    makeShipment(shipPayload)
      .then((response) => {
        responseHandle(response);
      })
      .catch((e) => {
        setShippingError(JSON.stringify(e?.response?.data?.error));
      });
  }
  function makeAddLeg(payload: any) {
    let newPayload: any = payload;
    newPayload.shipment_legs = payload.service;
    delete newPayload?.packages;
    delete newPayload?.booking_date;
    delete newPayload?.service;
    delete newPayload?.origin;
    delete newPayload?.destination;
    delete newPayload?.pickup;
    delete newPayload?.is_pickup;

    delete newPayload?.account_number;
    delete newPayload?.freight;
    delete newPayload?.surcharge;
    delete newPayload?.tax;
    delete newPayload?.cost;
    delete newPayload?.billing;
    delete newPayload?.special_instructions;
    delete newPayload?.is_declared_dangerous_goods;
    newPayload.documents = payload?.documents ? payload?.documents : [];

    addLegInShipment(newPayload)
      .then((response) => {
        responseHandle(response);
      })
      .catch((e) => {
        setShippingError(JSON.stringify(e?.response?.data?.error));
      });
  }

  function makeManualShipment(payload: any) {
    let manualShipmentPayload = payload;
    delete manualShipmentPayload.service;
    delete manualShipmentPayload.billing;
    delete manualShipmentPayload.pickup;
    delete manualShipmentPayload.documents;

    manualShipment(payload)
      .then((response) => {
        responseHandle(response);
      })
      .catch((e) => {
        setShippingError(JSON.stringify(e?.response?.data?.error));
      });
  }
  function responseHandle(response: any) {
    if (response?.data?.is_error === false) {
      let shipmentId = isManualLegs
        ? response?.data?.content
        : response?.data?.content?.shipment_id;
      if (isManualLegs) {
        navigate(`/app/admin/shipment-history/view?shipment_id=${shipmentId}`, {
          state: { additionalData: response?.data?.content },
        });
      } else {
        navigate(`/app/ship-now/confirmation?shipment_id=${shipmentId}`, {
          state: { additionalData: response?.data?.content },
        });
      }
    }
  }
  return (
    <>
      {loading ? (
        <ShippingPaymentLoading
          shippingError={shippingError}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setShowPayment={setShowPayment}
          setShowSummary={setShowSummary}
          isManualLegs={isManualLegs}
          setShowLegsForm={setShowLegsForm}
          setShowBCScreen={setShowBCScreen}
        />
      ) : (
        <div>
          <div className='d-flex mt-4 mb-5 align-items-center justify-content-between '>
            <div
              style={{
                color: '#f8f8f8',
                cursor: 'default',
                userSelect: 'none',
              }}
            >
              Skip Payment
            </div>
            <div className=''>
              <div
                className='btn-group '
                role='group'
                aria-label='Basic example'
                style={{ backgroundColor: '#F3F0F0', borderRadius: '50px' }}
              >
                <div
                  onClick={() => handleSection('NF')}
                  id='new'
                  // type='button'
                  className={`lex-18-400 color-main ${
                    section === 'NF' && 'btn-ubbe-green'
                  }`}
                  style={{
                    borderTopLeftRadius: '50px',
                    borderBottomLeftRadius: '50px',
                    padding: '16px',
                    cursor: 'pointer',
                  }}
                >
                  New File
                </div>
                <div
                  onClick={() => handleSection('UF')}
                  id='existing'
                  // type='button'
                  className={`lex-18-400 color-main ${
                    section === 'UF' && 'btn-ubbe-green'
                  }`}
                  style={{
                    borderTopRightRadius: '50px',
                    borderBottomRightRadius: '50px',
                    padding: '16px',
                    cursor: 'pointer',
                  }}
                >
                  Existing File
                </div>
              </div>
            </div>
            <div
              onClick={() => handleSkipPayment('SK')}
              className='lex-main-18-400 text-decoration-underline cursor_pointer'
            >
              Skip Payment
            </div>
          </div>
          {section !== 'SK' ? (
            <BusinessCentralMainForm
              section={section}
              setBcCustomerCode={setBcCustomerCode}
              setBcCustomerName={setBcCustomerName}
              setBCTypeForm={setBCTypeForm}
              bcTypeForm={bcTypeForm}
              isAllIn={isAllIn}
              setIsAllIn={setIsAllIn}
              isHandling={isHandling}
              setIsHandling={setIsHandling}
            />
          ) : (
            <div className='d-flex m-auto flex-column  justify-content-center w-100 align-items-center'>
              <div>
                {' '}
                <img src={stairs_placeholder} />
              </div>
              <h2
                style={{ fontWeight: '300' }}
                className='lex-18-400 mt-3 cursor_pointer'
              >
                {' '}
                Click on "
                <u style={{ fontWeight: '400' }} onClick={() => handleShip()}>
                  {isAddLegs ? 'Add Leg' : 'Ship Package'}
                </u>
                "
              </h2>
            </div>
          )}
          {/* button here */}
          <div className='d-flex my-5 justify-content-between align-items-center'>
            <div className='flex-grow-1'>
              {!isManualLegs && (
                <p
                  className='btn btn-ubbe-new-back d-flex gap-2'
                  onClick={() => {
                    handleBack();
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='15'
                    height='8'
                    viewBox='0 0 15 8'
                    fill='none'
                  >
                    <path
                      d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                      fill='black'
                    />
                  </svg>
                  Back
                </p>
              )}
            </div>
            <div className=''>
              <p
                className='btn btn-ubbe-new-blue w-100 '
                onClick={() => {
                  handleShip();
                }}
              >
                {isAddLegs ? 'Add Leg' : 'Ship Package'}
              </p>
            </div>
          </div>
          {showAlert && (
            <AlertModal
              onClose={() => {
                setShowAlert(false);
                handleSection('NF');
              }}
              onSuccess={() => makeShipmentHandle()}
              description={description}
              title={'Skip'}
              confirmTitle={'Confirm'}
              variant='success'
            />
          )}
        </div>
      )}
    </>
  );
}

export default MainBusinessPaymentPage;
